import { faCrown } from '@fortawesome/free-solid-svg-icons/faCrown';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { AtiraLinkPlanType } from '../model/plan/types/AtiraLinkPlanType.enum';
import { Breakpoints } from '../theme/Breakpoints';
import { Rounded } from '../theme/Rounded';
import { Spacing } from '../theme/Spacing';
import { Tooltip } from '../utils/local-antd';
import { AtiraIcon } from './AtiraIcon';
import { Flex } from './Flex';
import { Text } from './Text';
import { UpgradeButton } from './UpgradeButton';

const ResponsiveContainer = styled(Flex)`
  align-items: center;
  @media (max-width: ${Breakpoints.DESKTOP}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Container = styled(Flex)`
  flex-direction: column;
  gap: ${Spacing.s};
  background-color: ${({ theme }) => theme.main}20;
  border-radius: ${Rounded.md};
  padding: ${Spacing.m};
`;

type PaidFeatureNoticeProps = {
  asPopup?: boolean;
  text?: string;
  children?: React.ReactNode;
  plan: AtiraLinkPlanType;
  showPopup?: boolean;
};

export const PaidFeatureNotice: React.FC<PaidFeatureNoticeProps> = ({
  asPopup,
  text,
  children,
  plan,
  showPopup = true,
}) => {
  const { t } = useTranslation();

  if (asPopup) {
    return showPopup ? (
      <Tooltip
        title={
          text ||
          t('paidPlanNotice.description', {
            plan: t(`common.${t(plan.toLowerCase())}`),
          })
        }
      >
        {children}
      </Tooltip>
    ) : (
      children
    );
  }

  return (
    <Container>
      <Flex alignItems="center" gap="s">
        <Text color="main" fontWeight={'bold'}>
          {t('paidPlanNotice.title', {
            plan: t(`common.${t(plan.toLowerCase())}`),
          })}
        </Text>

        <AtiraIcon icon={faCrown} color="main" size="2x" />
      </Flex>
      <ResponsiveContainer gap="s">
        <Text color="fgMuted">
          {t('paidPlanNotice.description', {
            plan: t(`common.${t(plan.toLowerCase())}`),
          })}
        </Text>

        <UpgradeButton />
      </ResponsiveContainer>
    </Container>
  );
};
